import Admin from "../Admin";
import React from "react";
import CardAdminRoleList from "../../../Component/Card/Admin/Role/CardAdminRoleList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminRoleList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminRoleList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/role",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Roles" buttons={buttons} />;
  }
}
